import Link from "next/link";
import {IconButton, Stack} from "@mui/material";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEnvelope} from "@fortawesome/pro-duotone-svg-icons";
import {faFacebookF, faLinkedin, faXTwitter} from '@fortawesome/free-brands-svg-icons';
import {ArticleUrlProps} from "@/src/_types/Article/article-sidebar";
import {useEffect, useState} from "react";
import {usePathname} from "next/navigation";

const ArticleShareButtons = (
    {
        articleUrl,
        title = ''
    }: {
        articleUrl?: ArticleUrlProps;
        title?: string;
    }
) => {
    const pathname = usePathname();
    const [shareUrl, setShareUrl] = useState("");

    useEffect(() => {
        if (typeof window !== "undefined") {
            setShareUrl(`${window.location.origin}${pathname}`);
        }
    }, [pathname]);


    const socialLinks = [
        {
            icon: faFacebookF,
            backgroundImage: 'linear-gradient(to bottom, #869ad3, #738bcc, #607bc5)',
            href: `https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`,
            label: 'Facebook'
        },
        {
            icon: faXTwitter,
            backgroundImage: 'linear-gradient(to bottom, #86ceee, #70c5eb, #5abce7)',
            href: `https://x.com/intent/tweet?url=${shareUrl}`,
            label: 'Twitter'
        },
        {
            icon: faLinkedin,
            backgroundImage: 'linear-gradient(to bottom, #50b4e9, #3aabe6, #23a1e3)',
            href: `https://www.linkedin.com/shareArticle?mini=true&url=${shareUrl}`,
            label: 'LinkedIn'
        },
        {
            icon: faEnvelope,
            backgroundImage: 'linear-gradient(to bottom, #f89c95, #f6867e, #f47066)',
            href: `https://t.me/share/url?url=${shareUrl}`,
            label: 'Email'
        }
    ];

    return (
        <Stack
            display="inline-flex"
            flexDirection="row"
            alignItems="center"
            justifyContent="center"
            gap={.4}
        >
            {
                socialLinks.map(item =>
                    <Link
                        href={item.href}
                        key={item.label}
                        target={"_blank"}
                    >
                        <IconButton
                            sx={{
                                backgroundImage: item.backgroundImage,
                                borderRadius: '6px',
                                fontSize: '1rem',
                                width: 40,
                                height: 40
                            }}>
                            <FontAwesomeIcon
                                color="white"
                                icon={item.icon}
                            />
                        </IconButton>
                    </Link>
                )
            }
        </Stack>
    )
}

export default ArticleShareButtons;
